export default "__VITE_ASSET__BF2f9dtF__"